<div class="chip-dropdown-wrapper">
  <div
    class="filter-chip"
    role="button"
    tabindex="0"
    [class.filter-chip--selected]="!!selected"
    [attr.aria-expanded]="dropdownOpen"
    (click)="openDropdown()"
    (keydown.enter)="openDropdown()"
    (keydown.space)="$event.preventDefault(); openDropdown()"
  >
    @if (!!selected) {
      <span class="filter-chip-text">{{ displayWith(selected) }}</span>
      <span
        class="chip-clear-btn"
        role="button"
        tabindex="0"
        (click)="onClear($event)"
        (keydown.enter)="onClear($event)"
        (keydown.space)="$event.preventDefault(); onClear($event)"
      >
        <mat-icon>close</mat-icon>
      </span>
    } @else {
      + {{ placeholder }}
    }
  </div>

  @if (dropdownOpen) {
    <div>
      <div
        class="dropdown-backdrop"
        (click)="closeDropdown()"
      ></div>
      <div
        #dropdownMenu
        class="filter-dropdown"
        (click)="$event.stopPropagation()"
      >
        <ng-content></ng-content>
      </div>
    </div>
  }
</div>
